import { Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import CustomPriceField from "components/CustomPriceField";
import SanitizedGrid from "components/SanitizedGrid";
import {
  ArrayField,
  Datagrid,
  Labeled,
  Show,
  ShowProps,
  TextField,
} from "react-admin";

const PaymentListPanel = (props: ShowProps) => (
  <Show
    {...props}
    /* disable the app title change when shown */
    title=" "
    hasEdit={false}
  >
    <SanitizedGrid container spacing={2}>
      <Grid item md={4} xs={12}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Payment Detail</Typography>
          </Grid>

          <Grid item xs={12}>
            <Labeled source="Payment Ref">
              <TextField source="paymentRef" emptyText="-" />
            </Labeled>
          </Grid>

          <Grid item xs={12}>
            <Labeled source="Payment Description">
              <TextField source="description" emptyText="-" />
            </Labeled>
          </Grid>

          <Grid item xs={12}>
            <Labeled source="Payment Expired">
              <CustomDateField source="expiredAt" isDateTime />
            </Labeled>
          </Grid>
        </SanitizedGrid>
      </Grid>

      <Grid item md={8} xs={12}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Invoices Detail</Typography>
          </Grid>

          <Grid item xs={12}>
            <ArrayField source="invoices" fieldKey="id">
              <Datagrid
                empty={<Typography variant="body2">No Result found</Typography>}
              >
                <TextField source="mbcRef" emptyText="-" />
                <TextField source="description" emptyText="-" />
                <CustomPriceField source="amount" />
              </Datagrid>
            </ArrayField>
          </Grid>
        </SanitizedGrid>
      </Grid>
    </SanitizedGrid>
  </Show>
);

export default PaymentListPanel;
